<template>
  <div>
    <span
      v-if="[1, 2].includes(curStatus)"
      @click="onOpen"
      class="color-blue status-link"
    >
      <template v-if="curStatus === 1"> 拦截订单 </template>
      <template v-else> 取消拦截 </template>
    </span>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      modal-append-to-body
      append-to-body
      destroy-on-close
      width="30%"
    >
      <div class="status-tip color-pink">
        <template v-if="curStatus === 1">
          <div><i class="el-icon-info"></i>确定发起拦截？</div>
          <div>发起拦截后，不保证拦截成功，请稍后刷新页面查看拦截结果！</div>
        </template>
        <template v-else-if="curStatus === 2">
          <div><i class="el-icon-info"></i>确认取消拦截？</div>
          <div>发起取消拦截后，不保证取消拦截成功，请稍后刷新页面查看拦截结果！</div>
        </template>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  props: {
    row: {
      type: Object, // 行数据
      default: () => {},
    },
    isOrder: {
      // 是否是订单信息
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detail: {}, // 详情信息
      detailLoading: false, // 详情的loading
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
    };
  },
  computed: {
    curStatus() {
      let curStatus = null;
      if (
        this.row.orderStatus <= 3 &&
        this.row.orderType != 3 &&
        (this.row.interceptOrderStatus === null || this.row.interceptOrderStatus == 5)
      ) {
        curStatus = 1;
      } else if (
        this.row.orderStatus == 3 &&
        this.row.orderType != 3 &&
        [0, 3, 4].includes(this.row.interceptOrderStatus)
      ) {
        curStatus = 2;
      }

      return curStatus;
    },
    title() {
      return this.curStatus === 1 ? "拦截订单" : "取消拦截";
    },
  },
  methods: {
    // 批量操作
    onOpen() {
      this.dialogVisible = true;
      this.getDetail();
    },

    // 请求列表
    async getDetail() {
      this.detailLoading = true;
      const params = {
        orderId: this.row.orderId,
      };
      const res = await MiniModel.getOrderDetail(params).finally(() => {
        this.detailLoading = false;
      });
      if (res.data.code === 200) {
        this.detail = res.data.data || {};
      }
    },
    // 确定
    async onSure() {
      // 发起拦截
      if (this.curStatus === 1) {
        const res = await MiniModel.orderIntercept({
          appKey: localStorage.getItem("appKeyMini"),
          orderUUID: this.row.orderUUID,
        });
        if (res.data.code == 200) {
          this.$message.success("拦截发起成功，请稍后刷新页面查看拦截结果！");
          this.onCancel();
        } else {
          this.$message.error(res.data.message);
        }
      } else if (this.curStatus === 2) {
        // 取消拦截
        const res = await MiniModel.cancelIntercept({
          appKey: localStorage.getItem("appKeyMini"),
          orderUUID: this.row.orderUUID,
        });
        if (res.data.code == 200) {
          this.$message.success("取消拦截发起成功，请稍后刷新页面查看拦截结果！");
          this.onCancel();
          this.$emit("refresh");
        } else {
          this.$message.error(res.data.message);
        }
      }
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.status {
  &-link {
    cursor: pointer;
  }
  &-tip {
    line-height: 30px;
  }
}
.el-icon-info {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/groupOrder/InterceptStatus.vue